import TextFieldMui from 'src/components/TextFieldMui'
import styled from 'styled-components'

export const Wrapper = styled.div`
  overflow-y: auto;
`
export const ModalForm = styled.form`
  padding: 16px 64px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const ModalActionArea = styled.div`
  margin-top: 16px;
  width: 100%;
  display: flex;
  justify-content: space-between;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
`

export const CustomTextField = styled(TextFieldMui)`
  margin: 0 !important;
  height: 2.5rem !important;
  width: 832px !important;
  margin: .5rem 0 .5rem 0 !important;

  & input {
    height: 1.5rem !important;
  }
`

export const ModalIncompatibleInvoicesContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: .8rem;
`

export const ModalIncompatibleInvoicesContainerItems = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const ModalIncompatibleInvoicesContainerInvoices = styled.div`
  display: flex;
  flex-direction: column;
`

export const ModalIncompatibleInvoicesContainerInvoicesList = styled.ul`
`

export const ModalIncompatibleInvoicesContainerInvoicesListItem = styled.li`
  list-style-type: disc;
  font-size: 15px;
  font-family: Work Sans;
  margin-left: 1.5rem;
  font-weight: bold;
`
